import React from 'react';
import { StatusBadge } from '../../../components/ui';
import type { SiteAttention } from '../types';

/**
 * A site's bins that need someone to act, one badge per reason, worst first. A site with
 * nothing to act on says so plainly rather than showing an empty cell, so "no flags" is never
 * mistaken for "not loaded".
 */
const AttentionBadges: React.FC<{ attention: SiteAttention }> = ({ attention }) => {
  const badges = [
    attention.negative > 0 && { key: 'negative', label: `${attention.negative} below zero`, variant: 'danger' as const },
    attention.belowMin > 0 && { key: 'below-min', label: `${attention.belowMin} below min`, variant: 'danger' as const },
    attention.overMax > 0 && { key: 'over-max', label: `${attention.overMax} over max`, variant: 'warning' as const },
  ].filter(Boolean) as { key: string; label: string; variant: 'danger' | 'warning' }[];

  if (badges.length === 0) {
    return <span className="tw-text-xs tw-text-content-muted">All in range</span>;
  }
  return (
    <span className="tw-flex tw-flex-wrap tw-gap-1">
      {badges.map((badge) => (
        <StatusBadge key={badge.key} status={badge.key} label={badge.label} variant={badge.variant} soft pill />
      ))}
    </span>
  );
};

export default AttentionBadges;
